"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
var colors_1 = __importDefault(require("../tokens/colors"));
exports.colors = colors_1.default;
//# sourceMappingURL=colors.js.map